import { useRouter, computed, useRoute } from '@nuxtjs/composition-api'

export default function useHistoricalRevisions() {
  const router = useRouter()
  const route = useRoute()

  const includeHistoricalRevisions = computed({
    get: () => {
      const includeHistoricalRevisions = route.value.query.includeHistoricalRevisions === 'true'
      return includeHistoricalRevisions || false
    },
    set: (value) => {
      router.push({ query: { ...route.value.query, includeHistoricalRevisions: value, page: 1 } })
    },
  })

  return { includeHistoricalRevisions }
}
